import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';
import { toast } from 'sonner';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_940e8ae3-c19e-4add-8a26-04b3a3541f3d/artifacts/59pes23f_logocafe.png";

export default function AdminLogin() {
  const { user, loading: authLoading, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState(() => localStorage.getItem('last_admin_email') || '');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!authLoading && user) {
      if (user.role === 'admin' || user.role === 'vendedora' || user.role === 'vendedor') {
        navigate('/admin', { replace: true });
      } else if (user.role === 'produccion' || user.role === 'producción') {
        navigate('/admin/produccion', { replace: true });
      } else if (user.role === 'domiciliario') {
        navigate('/admin/entregas', { replace: true });
      }
    }
  }, [user, authLoading, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const data = await login(email, password);
      localStorage.setItem('last_admin_email', email);
      if (data.role === 'admin') {
        toast.success('Bienvenido al panel admin');
        navigate('/admin');
      } else if (data.role === 'vendedora' || data.role === 'vendedor') {
        toast.success('Bienvenido');
        navigate('/admin');
      } else if (data.role === 'produccion' || data.role === 'producción') {
        toast.success('Bienvenido');
        navigate('/admin/produccion');
      } else if (data.role === 'domiciliario') {
        toast.success('Bienvenido, Domiciliario');
        navigate('/admin/entregas');
      } else {
        setError('No tienes permisos de acceso');
      }
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : Array.isArray(detail) ? detail.map(e => e.msg).join(' ') : 'Error al iniciar sesion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f4f1ea] flex items-center justify-center px-4" data-testid="admin-login-page">
      <Card className="w-full max-w-md p-8 border border-[#e5dfd3] rounded-2xl bg-[#fcfbf9]">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Keiks" className="h-14 mx-auto mb-4" />
          <h1 className="font-heading text-2xl font-bold text-[#46371c]">Panel Administrativo</h1>
          <p className="font-body text-sm text-[#75664d] mt-1">Ingresa con tu cuenta de administrador</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && <div className="bg-red-50 text-red-600 text-sm p-3 rounded-xl font-body" data-testid="login-error">{error}</div>}
          <div>
            <label className="font-body text-sm text-[#75664d] mb-1 block">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              className="w-full h-11 px-4 rounded-xl border border-[#e5dfd3] font-body text-sm text-[#46371c] focus:outline-none focus:border-[#a0d5ba]"
            />
          </div>
          <div>
            <label className="font-body text-sm text-[#75664d] mb-1 block">Contrasena</label>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              className="w-full h-11 px-4 rounded-xl border border-[#e5dfd3] font-body text-sm text-[#46371c] focus:outline-none focus:border-[#a0d5ba]"
            />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#46371c] text-[#fcfbf9] hover:bg-[#2d2312] rounded-full h-11 font-body" data-testid="admin-login-btn">
            {loading ? 'Ingresando...' : 'Ingresar'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
